import { createApi, fetchBaseQuery, retry } from '@reduxjs/toolkit/query/react';
import { RootState } from '../../store/store';
import { queryParams } from '../../utils/query-string';
import { IListResponse } from '../../configs/constants';
import { IParams, IUnits } from '../../modules/Units/units';

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_BASE_URL,
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as RootState).auth.token;
    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  },
});

const baseQueryWithRetry = retry(baseQuery, { maxRetries: 2 });

export const unitDropdownApi = createApi({
  reducerPath: 'unitDropdownApi',
  baseQuery: baseQueryWithRetry,
  tagTypes: ['UnitDropdown'],
  endpoints: (builder) => ({
    getUnits: builder.query<
      IListResponse<IUnits>,
      { page: number; pageSize: number; keyword?: string }
    >({
      query: ({ page, pageSize, keyword }) => {
        const params: IParams = {
          take: pageSize,
          skip: (page - 1) * pageSize,
        };
        if (keyword) params.keyword = keyword;
        return {
          url: `units?${queryParams(params)}`,
          method: 'GET',
        };
      },
      providesTags: ['UnitDropdown'],
    }),
  }),
});

export const { useGetUnitsQuery } = unitDropdownApi;
